import React, { useState } from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import {
  ContainerRequestState,
  PendingModifyText,
  RequestStateDate,
  RequestStateText,
  RequestStateTitle
} from './styles';
import imgApproved from '../../../../../../../assets/illustrations/ilustracion_approve.svg';
import imgDisapproved from '../../../../../../../assets/illustrations/ilustracion_disapproved.svg';
import imgProgress from '../../../../../../../assets/illustrations/ilustracion_process.svg';
import imgApprovedDsk from '../../../../../../../assets/illustrations/ilustracion-approved-desktop.svg';
import imgDisapprovedDsk from '../../../../../../../assets/illustrations/ilustración_disapproved_dsk.svg';
import imgProgressDsk from '../../../../../../../assets/illustrations/ilustracion_process_dsk.svg';

import imgCalendar from '../../../../../../../assets/icons/icon-calendar.svg';
import FileUpload from '../../../../../../reusables/Upload';
import FormButtons from './FormButtons';
import TextHelper from '../../../../../../../core/helpers/TextHelper';
import { LineSeparatorTop } from '../../../../../../_components/footer/styled';
import DateHelpers from '../../../../../../../core/helpers/DateHelper';
import IDHelpers from '../../../../../../../core/helpers/IDHelper';
import WarningMessage from '@/presentation/reusables/WarningMessage';
import ContentModalTwoButtons from '@/presentation/modules/procedures/components/ContentModalTwoButtons';
import Modal from '@/presentation/modules/procedures/components/Modal/Modal';

interface IRequestStateCard {
  reqState: string;
  reqDate?: number | string;
  reqStaffText: string;
  approvedBsePercentage?: string | number;

  // Esto es para FileUpload
  sendDocuments?: (data: any) => void;
  // documentsBse: any;
  deleteUploadedFile?: (ids: number[]) => void;
  downloadUploadedFile?: (path: string) => void;
  aditionalDocuments?: any[];
  isValidDocuments?: boolean;
  setIsValidDocuments?: (isValid: boolean) => void;
  expirationDate?: number;
  isLastAttempt: boolean;
}

const getBackgroundImage = (reqState: string, isDesktop: boolean): any => {
  const images: any = {
    FINALIZED_SUCCESS: isDesktop ? imgApprovedDsk : imgApproved,
    FINALIZED_UNSUCCESS: isDesktop ? imgDisapprovedDsk : imgDisapproved,
    PENDING_ATTENTION: isDesktop ? imgProgressDsk : imgProgress
  };

  return `url("${images[reqState] || ''}")`;
};

const ImageResponse = styled.div<{ reqState: string }>`
  background-image: ${(props) => getBackgroundImage(props.reqState, false)};
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 88px;
  background-color: #d5e4f0;
  background-position: center;
  border-radius: 8px;

  @media (min-width: 768px) {
    background-image: ${(props) => getBackgroundImage(props.reqState, true)};
    width: 360px;
    height: 180px;
  }
`;

const RequestStateCard = (props: IRequestStateCard) => {
  const {
    reqState,
    reqDate,
    reqStaffText,
    approvedBsePercentage,
    deleteUploadedFile,
    sendDocuments,
    downloadUploadedFile,
    aditionalDocuments,
    isValidDocuments,
    setIsValidDocuments,
    expirationDate,
    isLastAttempt
  } = props;

  const stateMapping: Record<
    string,
    { img: string; title: string; text: (percentage?: number) => string }
  > = {
    PENDIENTE: {
      img: 'PENDING_ATTENTION',
      title: 'Tu solicitud está en proceso',
      text: () =>
        'Te notificaremos por correo cuando tu solicitud esté finalizada.'
    },
    NO_PROCEDE: {
      img: 'FINALIZED_UNSUCCESS',
      title: 'Tu solicitud no puede proceder',
      text: () => 'Tu foto no ha cumplido con los requisitos:'
    },
    PROCEDE: {
      img: 'FINALIZED_SUCCESS',
      title: 'Tu solicitud ha sido aprobada',
      text: () => 'Tu foto ha sido actualizada.'
    },
    FINALIZED_SUCCESS: {
      img: 'FINALIZED_SUCCESS',
      title: 'Tu solicitud ha sido aprobada',
      text: (percentage) =>
        `Te hemos otorgado la beca socioeconómica que equivale a un <b> descuento de ${
          percentage?.toString() ?? ''
        }% </b> en tus cuotas pendientes (no vencidas).`
    },
    FINALIZED_UNSUCCESS: {
      img: 'FINALIZED_UNSUCCESS',
      title: 'Tu solicitud no procede',
      text: () => ''
    },
    PENDING_ATTENTION: {
      img: 'PENDING_ATTENTION',
      title: 'Tu solicitud está en proceso',
      text: () => 'Estamos revisando tu solicitud.'
    },
    PENDING_MODIFY: {
      img: 'PENDING_MODIFY',
      title: 'Tu solicitud tiene documentos que faltan o no coinciden',
      text: () => ''
    }
  };

  const {
    img: reqStateImg,
    title,
    text: getText
  } = stateMapping[reqState] || { img: reqState, title: '', text: () => '' };
  let text: any = getText(
    typeof approvedBsePercentage === 'string'
      ? parseFloat(approvedBsePercentage) || undefined
      : approvedBsePercentage
  );

  if (reqStaffText) {
    text = parse(reqStaffText);
  }
  if (reqState === 'FINALIZED_SUCCESS') {
    text = parse(text);
  }

  // //AÑADIDO NUEVO FILE UPLOAD////////////////////////////////////

  const [form, setForm] = useState<any[]>([
    {
      // component: additionalInformation,
      error: false,
      fileName: 'POR_MODIFCAR',
      files: aditionalDocuments,
      idConcept: '12',
      isOk: false,
      show: false,
      title: 'Por modificar'
    }
  ]);

  const [showPopupAttempts, setShowPopupAttempts] = useState(false);

  const controllerProperty = (property: string, value: any) => {
    form[0][property] = value;
    setForm([...form]);
  };

  const controllerDelete = (files: any[]) => {
    const arr: number[] = [];
    files.forEach((file) => {
      arr.push(Number(file.id));
    });
    if (deleteUploadedFile) deleteUploadedFile(arr);
  };

  const saveForm = () => {
    if (form[0].files.length > 0) {
      const temporaryArr: any[] = form[0].files.map(
        (file: any, index: number) => ({
          base64: file.base64,
          fileName: `${form[0].fileName}-${index + 1}.${file.ext}`,
          idConcept: form[0].idConcept,
          originalFileName: file.originalName
        })
      );

      const arr = temporaryArr.filter((v) => v.base64);

      if (sendDocuments) sendDocuments(arr);
    }
  };

  const evalAttempts = () => {
    if (isLastAttempt) setShowPopupAttempts(true);
    else saveForm();
  };

  const comentary = reqStaffText?.toString()?.split('|');

  return (
    <ContainerRequestState data-testid="cmp-request-state">
      <div className="wrapper">
        {reqStateImg !== 'PENDING_MODIFY' ? (
          <ImageResponse reqState={reqStateImg} />
        ) : null}
        <div className="wrapper__content">
          <RequestStateTitle>{title}</RequestStateTitle>
          <div>
            {reqDate &&
            (reqStateImg === 'PENDING_ATTENTION' ||
              reqStateImg === 'PENDING_MODIFY') ? (
              <RequestStateDate>
                <img
                  src={imgCalendar}
                  alt="img calendar"
                  width="12"
                  height="13.5"
                />
                {reqStateImg === 'PENDING_ATTENTION'
                  ? parse(
                      `<b>Documentos enviados:</b> ${TextHelper.capitalize(
                        String(reqDate)
                      )?.toLowerCase()}`
                    )
                  : parse(
                      `<b>Atendido por SAE:</b> ${TextHelper.capitalize(
                        String(reqDate)
                      )?.toLowerCase()}`
                    )}
              </RequestStateDate>
            ) : null}
            {reqStateImg === 'PENDING_MODIFY' && expirationDate ? (
              <>
                <PendingModifyText>
                  <ul>
                    <li>{text}</li>
                  </ul>
                  <LineSeparatorTop
                    style={{ margin: '8px 0px', color: '#7A959F' }}
                  />
                  <b>
                    Fecha límite para enviar:{' '}
                    {TextHelper.capitalize(
                      DateHelpers.formatDate(
                        expirationDate +
                          new Date().getTimezoneOffset() * 60 * 1000
                      ) || ''
                    )?.toLowerCase()}
                  </b>
                  <br />
                  Pasado este tiempo y de no haber una respuesta, se dará por
                  finalizado el trámite. Tampoco se devolverá el monto pagado
                  por la solicitud.
                </PendingModifyText>

                <WarningMessage
                  message="Asegúrate de adjuntar los documentos correctos. Si no cumple con lo observado, la solicitud no procederá."
                  styledProps={{
                    iconSize: 20,
                    fontSize: '14px',
                    borderRadius: '8px',
                    padding: '0 0 24px',
                    alignItems: 'start',
                    gap: '8px'
                  }}
                />

                <FileUpload
                  idValue="id"
                  nameValue="originalName"
                  pathValue="path"
                  sizeValue="size"
                  acceptedFiles={['pdf', 'ppt', 'word', 'excel', 'jpg']}
                  dataFiles={form[0].files}
                  maxSizeMegabytes={30}
                  maxFiles={10}
                  emitFiles={(files) => {
                    controllerProperty('files', files);
                  }}
                  deleteFiles={(files) => {
                    controllerDelete(files);
                  }}
                  downloadFiles={(files) => {
                    if (downloadUploadedFile)
                      downloadUploadedFile(files[0].path);
                  }}
                  validateDocuments={setIsValidDocuments}
                />
                <FormButtons
                  // handlerSend={() => saveForm(form)}
                  handlerSend={() => evalAttempts()}
                  handlerNext={() => {}}
                  formIsValid={
                    (form[0].files.length > 0 && isValidDocuments) || false
                  }
                  onlySaveButton
                />
              </>
            ) : null}
            {reqStateImg !== 'PENDING_MODIFY' && (
              <>
                <RequestStateText>{text}</RequestStateText>
                {reqStaffText &&
                reqState !== 'FINALIZED_SUCCESS' &&
                reqState !== 'FINALIZED_UNSUCCESS' ? (
                  <div>
                    <ul
                      style={{
                        margin: '20px 0px 0px 15px',
                        listStyle: 'outside',
                        listStyleType: 'disc'
                      }}
                    >
                      {comentary?.map((r: string) => (
                        <li key={IDHelpers.generateID()}>{r}</li>
                      ))}
                    </ul>
                  </div>
                ) : null}
                {reqState !== 'FINALIZED_UNSUCCESS' &&
                  reqState !== 'FINALIZED_SUCCESS' && (
                    <WarningMessage
                      message="Te avisaremos por correo UTP cuando tengas una respuesta."
                      styledProps={{
                        background: '#D5E5F0',
                        iconSize: 20,
                        fontSize: '14px',
                        borderRadius: '8px',
                        padding: '16px',
                        alignItems: 'start',
                        gap: '8px',
                        margin: '12px 0 0 0'
                      }}
                    />
                  )}
              </>
            )}
          </div>
        </div>
      </div>
      <Modal
        show={showPopupAttempts}
        handleClose={() => setShowPopupAttempts(false)}
      >
        <ContentModalTwoButtons
          img={undefined}
          title="¿Estás seguro de enviar tus documentos? Es tu último intento."
          subtitle="Asegúrate de adjuntar los documentos correctos. Si no cumple con lo observado, la solicitud no procederá."
          showInfo={false}
          textButton1={'Sí, enviar'}
          onClickButton1={() => saveForm()}
          textButton2={'Cancelar'}
          onClickButton2={() => setShowPopupAttempts(false)}
        />
      </Modal>
    </ContainerRequestState>
  );
};

export default RequestStateCard;
